import { toDate } from 'date-fns-tz'

export const UTC_TIMEZONE = 'UTC'

/**
 * Parses a backend datetime string into a Date for local display.
 *
 * Backends serialise datetimes in two shapes: the Rust GraphQL emits
 * RFC3339 with an explicit offset (2026-06-10T13:00:00+00:00), while
 * naive strings without an offset are UTC wall times by convention.
 * toDate handles both: it honours an offset when present and otherwise
 * interprets the wall time in the given timezone.
 *
 * Do not use fromZonedTime here. For offset-bearing strings it rebuilds
 * the instant from the browser's local wall clock, which displayed
 * every timestamp an hour in the future during BST (EN-212).
 */
export function getInLocalTime(utcDateInISOFormat: string): Date {
    return toDate(utcDateInISOFormat, { timeZone: UTC_TIMEZONE })
}

/**
 * A duration for a diagnostic readout: milliseconds under a second, then
 * seconds to two places. Sub-second precision matters because that is the
 * range these numbers live in — a search worth reading about is either 90ms or
 * 12s, and rounding the first to "0s" loses the only interesting part.
 *
 * Not the formatter for a live ticker (see SearchStatusIndicator, which is
 * deliberately coarse) or for job history (ScheduledWorkHistoryModal, 1dp).
 * — Claude
 */
export function formatDuration(ms: number): string {
    return ms < 1000 ? `${ms}ms` : `${(ms / 1000).toFixed(2)}s`
}
